import { FC, useCallback, useRef } from 'react';
import { AllieToggle } from './Toggle';
import { AllieToggleProps } from './Toggle.types';

export const AllieToggleOptimized: FC<AllieToggleProps> = ({ onIonChange, ...props }) => {
  const isChanging = useRef(false);

  const handleChange = useCallback((e: any) => {
    if (isChanging.current) return;
    
    isChanging.current = true;
    onIonChange?.(e);

    setTimeout(() => {
      isChanging.current = false;
    }, 0);
  }, [onIonChange]);

  return <AllieToggle {...props} onIonChange={handleChange} />;
}; 
